module.exports = __webpack_public_path__ + "static/media/boxes.739eb9d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/boxes.png
// module id = 357
// module chunks = 0